<div
    class="flex flex-column gap-3 justify-content-center pin-view-container align-content-center align-items-center text-center">
    <!-- <div>
        <span class="title">
            <app-translate key="PAGE_NOT_FOUND"></app-translate>
        </span>
    </div> -->
    <div>
        <span class="sub-title">
            <app-translate key="USE_AGENT_ACCESS"></app-translate>
        </span>
    </div>
</div>